/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findIndex = require('./findIndex');

var MetricsCacheInMemory = function () {
  function MetricsCacheInMemory() {
    (0, _classCallCheck3.default)(this, MetricsCacheInMemory);

    this.clear();
  }

  /**
   * Recycle the collector (reset using 0 for all the counters)
   */


  (0, _createClass3.default)(MetricsCacheInMemory, [{
    key: 'clear',
    value: function clear() {
      this.counters = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      return this;
    }

    /**
     * Latency counters based on the internal ranges
     */

  }, {
    key: 'state',
    value: function state() {
      return this.counters;
    }

    /**
     * Store latency and return the number of occurrencies inside the range defined
     */

  }, {
    key: 'track',
    value: function track(latency) {
      this.counters[findIndex(latency)]++;

      return this;
    }

    /**
     * Check if the is data changed from the defaults
     */

  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.counters.reduce(function (sum, e) {
        return sum += e;
      }, 0) === 0;
    }

    /**
     * Hook JSON.stringify to expose the state of the counters
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      return this.counters;
    }
  }]);
  return MetricsCacheInMemory;
}();

module.exports = MetricsCacheInMemory;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/storage/MetricsCache/InMemory.js
// module id = 1235
// module chunks = 0